export default "__VITE_ASSET__PgL5B6hu__"